import PropTypes from 'prop-types';
import { Select, MenuItem, IconButton, Grid, Tooltip } from '@mui/material';
import { REPORT_DOWNLOAD_OPTIONS } from '../../../../utils/constants';
import { useState } from 'react';
import { LibraryBooks, PreviewRounded, PrintRounded } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { checkHydraulicsAdmin } from '../../../../utils/checkPermissions';

const ReportsDownloadSelector = ({
  onDataDownload,
  onPreviewOpen,
  loading
}) => {
  const [reportSelection, setReportSelection] = useState(REPORT_DOWNLOAD_OPTIONS[0]);
  const user = useSelector((state) => state.currentUser);
  const REPORT_ICONS = {
    View: {
      icon: <PreviewRounded fontSize="large" />,
      preview: true,
      tooltipContent: 'View Report'
    },
    Print: {
      icon: <PrintRounded fontSize="large" />,
      preview: false,
      tooltipContent: 'Print Report'
    },
    Data: {
      icon: <LibraryBooks fontSize="large" />,
      preview: false,
      tooltipContent: 'Report Data'
    }
  };

  const selectedReport = REPORT_ICONS[reportSelection];
  return (
    <>
      <Grid item mr={2}>
        Report
      </Grid>

      <Select
        id="filter-id"
        value={reportSelection}
        disabled={loading}
        onChange={(e) => setReportSelection(e.target.value)}
        sx={{
          fontSize: '18px',
          fontWeight: 'bold',
          background: 'unset',
          height: '40px',
          mr: 1
        }}
      >
        {REPORT_DOWNLOAD_OPTIONS?.filter(
          (item) =>
            item !== 'Data' ||
            checkHydraulicsAdmin(
              user?.type,
              user?.accessLevels
            )
        ).map((item, index) => (
          <MenuItem
            key={`item_${item}_${index}`}
            value={item}
            sx={{ fontSize: '18px', fontWeight: 'bold' }}
          >
            {item}
          </MenuItem>
        ))}
      </Select>

      {selectedReport && (
              <Tooltip title={selectedReport?.tooltipContent}>
                  <span>
                      <IconButton
                          disabled={loading}
                          onClick={() => {
                            if (reportSelection === 'Data') {
                              onDataDownload();
                              return;
                            }
                            onPreviewOpen(selectedReport?.preview);
                          }}
                      >
                          {selectedReport.icon}
                      </IconButton>
                  </span>
              </Tooltip>
      )}
    </>
  );
};
ReportsDownloadSelector.propTypes = {
  onDataDownload: PropTypes.func.isRequired,
  onPreviewOpen: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ReportsDownloadSelector;
